import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/store/redux';

const SLICE_NAME = 'tradein/prices';

export interface ITradeInPricesState {
  finalPrice: number | null;
  minimalPrice: number | null;
  maximalPrice: number | null;
}

const initialState: ITradeInPricesState = {
  finalPrice: null,
  minimalPrice: null,
  maximalPrice: null,
};

export const tradeInPricesSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setTradeInPrices: (state, action: PayloadAction<ITradeInPricesState>) => {
      state.finalPrice = action.payload.finalPrice;
      state.minimalPrice = action.payload.minimalPrice;
      state.maximalPrice = action.payload.maximalPrice;
    },
    resetTradeInPrices: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { setTradeInPrices, resetTradeInPrices } =
  tradeInPricesSlice.actions;

export const getTradeInPricesState = (state: RootState): ITradeInPricesState =>
  state.pages.tradeIn.prices;

export default tradeInPricesSlice.reducer;
